import { useContext } from 'react'

import { LayoutOverlayContext } from '../../context'

export function useLayoutOverlayContext() {
  return useContext(LayoutOverlayContext)
}
